import React from 'react';
import { useSpecialties } from './SpecialtiesProvider';

export const SpecialtyLabel: React.FC<{ id: string }> = ({ id }) => {
  const specialties = useSpecialties();
  const specialty = specialties.find(sp => sp.sys.id === id);
  return <>{specialty?.fields?.name?.['en-US'] ?? 'Unknown'}</>;
};
